import { selectedHistory, historySummary, measured } from "./teamAnalysis";
// Intersect each metric separately: goal coverage must never stand in for points coverage.
export function performanceComparison(
  observations,
  id,
  model = "result",
  { recent = 0, venue = "all" } = {}
) {
  const selected = selectedHistory(observations || [], id).filter(
    (g) => venue === "all" || g[venue + "_team_id"] === Number(id)
  );
  const games = recent ? selected.slice(0, recent) : selected;
  const compare = (basis) => {
    const goalGames = games.filter(
      (g) =>
        historySummary([g], id, "should").count &&
        historySummary([g], id, basis).count
    );
    const pointGames = games.filter(
      (g) =>
        historySummary([g], id, "should").outcomes &&
        historySummary([g], id, basis).outcomes
    );
    const a = historySummary(goalGames, id, "should"),
      b = historySummary(goalGames, id, basis);
    const pa = historySummary(pointGames, id, "should").outcomes,
      pb = historySummary(pointGames, id, basis).outcomes;
    return {
      goals: goalGames.length
        ? (a.for - a.against - b.for + b.against) / goalGames.length
        : null,
      points: pointGames.length
        ? (pa.points - pb.points) / pointGames.length
        : null,
      goalCount: goalGames.length,
      pointCount: pointGames.length,
    };
  };
  return {
    count: games.length,
    games,
    expected: compare(model),
    result: compare("real"),
  };
}
export function matchPerformance(game, id, model = "result") {
  const pair = performanceComparison([game], id, model);
  const home = game.home_team_id === Number(id),
    f = home ? game.goals?.home : game.goals?.away,
    a = home ? game.goals?.away : game.goals?.home;
  return {
    ...pair.expected,
    result:
      measured(f) && measured(a) ? (f > a ? "S" : f === a ? "U" : "N") : null,
  };
}
